module.exports = __webpack_public_path__ + "static/media/productionProcess.c28288b4.png";